import { Reveal } from "@/components/Reveal";
import { PARTNERS } from "@/data/siteData";

export const Partners = () => (
  <section data-testid="partners-section" className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
    <Reveal>
      <p className="eyebrow text-primary">Certified service partner with</p>
      <p className="mt-3 max-w-xl text-sm font-light text-muted-foreground">
        If one of these brands is on your roof, we are authorized to diagnose, repair and process warranty work for it.
      </p>
      <div className="mt-8 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-border bg-border sm:grid-cols-3 lg:grid-cols-6">
        {PARTNERS.map((p) => (
          <div key={p.name} data-testid={`partner-${p.name.toLowerCase()}`} className="flex h-28 items-center justify-center bg-white px-8">
            <img src={p.logo} alt={`${p.name} logo`} title={p.name} loading="lazy" className="max-h-12 w-full object-contain" />
          </div>
        ))}
      </div>
    </Reveal>
  </section>
);
